import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { 
  Scissors, // For Easy-to-Open Design
  ShieldCheck, // For Durable Construction
  Box, // For Flat Square Bottom
  Leaf // For Eco-Friendly Material
} from 'lucide-react';

const ProductCategory2 = () => {
  const features = [
    {
      icon: Scissors,
      title: "Easy-to-Open Design",
      description: "Pre-creased folds allow quick and hassle-free opening, ideal for high-volume use.",
      bgColor: "#FF9800" // Orange for easy opening
    },
    {
      icon: ShieldCheck,
      title: "Durable Construction",
      description: "Made from thick kraft paper to withstand heavy loads without tearing.",
      bgColor: "#8B4513" // Brown for durability
    },
    {
      icon: Box,
      title: "Flat Square Bottom",
      description: "Provides stability, making it perfect for carrying boxed or flat-bottomed items.",
      bgColor: "#CD853F" // Light brown for structure
    },
    {
      icon: Leaf,
      title: "Eco-Friendly Material",
      description: "100% recyclable and biodegradable, aligning with sustainable packaging trends.",
      bgColor: "#4CAF50" // Green for eco-friendly
    }
  ];

  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h2 className="main-heading display-5 fw-bold mb-3">Discover Features</h2>
        <p className="product-each-desc text-muted mx-auto" style={{ maxWidth: '700px' }}>
          Eco-friendly, easy-to-open design, durable construction, flat square bottom, self-opening square bags for sustainable and stylish packaging solutions.
        </p>
      </div>

      <div className="row g-4">
        {features.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <div className="card h-100 border-0 shadow-sm feature-card">
                <div className="text-center mt-4">
                  <div 
                    className="icon-container d-inline-flex align-items-center justify-content-center rounded-3 mb-4"
                    style={{ background: feature.bgColor }}
                  >
                    <IconComponent size={40} className="icon-img" />
                  </div>
                </div>
                
                <div className="card-body text-center">
                  <h3 className="card-title h5 mb-3">{feature.title}</h3>
                  <p className="card-text text-muted mb-4">{feature.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <style>
        {`
          .feature-card {
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .feature-card::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 3px;
            background-color: #dc3545;
            transition: width 0.3s ease;
          }

          .feature-card:hover {
            transform: translateY(-10px);
          }

          .feature-card:hover::after {
            width: 100%;
          }

          .icon-container {
            width: 80px;
            height: 80px;
            transition: all 0.3s ease;
          }

          .icon-img {
            color: white;
          }

          .feature-card:hover .icon-container {
            transform: scale(1.1);
          }
        `}
      </style>
    </div>
  );
};

export default ProductCategory2;